import { render, staticRenderFns } from "./productPageRoute.vue?vue&type=template&id=ec4e6410&"
import script from "./productPageRoute.vue?vue&type=script&lang=js&"
export * from "./productPageRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports